'use client';

import { cn } from '@/lib/ui/cn';
import { useMemo } from 'react';

import './IntakeProgressBar.scss';

const MAX_PERCENT = 100;

type Props = {
  currentStep: number;
  totalSteps: number;
  className?: string;
};

export const IntakeProgressBar = ({
  currentStep,
  totalSteps,
  className,
}: Props) => {
  const progress = useMemo(
    () => (totalSteps > 0 ? (currentStep / totalSteps) * MAX_PERCENT : 0),
    [currentStep, totalSteps]
  );

  return (
    <div
      className={cn(
        'IntakeProgressBar h-1.5 w-full overflow-hidden rounded-full',
        className
      )}
    >
      <div
        className='IntakeProgressBar__content h-full rounded-full'
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};
